import {
  AccessCodeDto,
  AccessCodeModel,
  mapAccessCodeDtoToModel,
  mapAccessCodeModelToDto,
} from 'api/dto/AccessCode.dto';

export type FailedEmailsDto = {
  status: number;
} & AccessCodeDto;

export type FailedEmailsModel = {
  status: number;
  accessCode: AccessCodeModel;
};

export function mapFailedEmailsModelToDto(model: FailedEmailsModel): FailedEmailsDto {
  return {
    status: model.status,
    ...mapAccessCodeModelToDto(model.accessCode),
  };
}

export function mapFailedEmailsDtoToModel(dto: FailedEmailsDto): FailedEmailsModel {
  return {
    status: dto.status,
    accessCode: mapAccessCodeDtoToModel(dto),
  };
}
